module.exports = __webpack_public_path__ + "static/media/Love-Coding.5683999a.mp4";